// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oilReportModal__awD0H {
  width: 372px;
  height: 464px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modalBody__TPUBQ {
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.modalBodyTitle__HnfnM {
  text-align: center;
  margin-bottom: 25px;
  color: var(--header-title-main);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
}

.reportsWrapper__Qkrcg {
  width: 100%;
  height: 100%;
  max-height: 230px;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  overflow-y: auto;
}
.reportsWrapper__Qkrcg::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.reportsWrapper__Qkrcg::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.reportsWrapper__Qkrcg::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.reportsWrapper__Qkrcg::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.reportItem__kO95Y {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-radius: 2px;
  border: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-secondary-row-sub-title-surface);
  box-shadow: var(--select-dropdown-box-shadow);
}

.reportItemName__mE4y8 {
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
  color: var(--inputs-search-text-filled);
  text-transform: uppercase;
}

.reportItemDate__Yrmax {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--tables-primary-row-text-additional);
  display: block;
  margin-top: 3px;
}

.modalFooter__wK7wQ {
  padding: 0 51px 35px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/OilReportModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,mBAAA;EA1BA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA9CF;;AAwEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AArEF;AATE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAWJ;AARE;EACE,+BAAA;EACA,kBAAA;AAUJ;AAPE;EACE,8BAAA;EACA,kBAAA;AASJ;AANE;EACE,gBAAA;EACA,kBAAA;AAQJ;;AAyDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kDAAA;EACA,yDAAA;EAEA,6CAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;EACA,yBAAA;AAvDF;;AA0DA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;EACA,cAAA;EACA,eAAA;AAvDF;;AA0DA;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAvDF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.oilReportModal {\n  width: 372px;\n  height: 464px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalBody {\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.modalBodyTitle {\n  text-align: center;\n  margin-bottom: 25px;\n\n  @include modalTitle;\n}\n\n.reportsWrapper {\n  width: 100%;\n  height: 100%;\n  max-height: 230px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n\n.reportItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  border-radius: 2px;\n  border: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-secondary-row-sub-title-surface);\n\n  box-shadow: var(--select-dropdown-box-shadow);\n}\n\n.reportItemName {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 12px;\n  color: var(--inputs-search-text-filled);\n  text-transform: uppercase;\n}\n\n.reportItemDate {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--tables-primary-row-text-additional);\n  display: block;\n  margin-top: 3px;\n}\n\n.modalFooter {\n  padding: 0 51px 35px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"oilReportModal": `oilReportModal__awD0H`,
	"modalBody": `modalBody__TPUBQ`,
	"modalBodyTitle": `modalBodyTitle__HnfnM`,
	"reportsWrapper": `reportsWrapper__Qkrcg`,
	"reportItem": `reportItem__kO95Y`,
	"reportItemName": `reportItemName__mE4y8`,
	"reportItemDate": `reportItemDate__Yrmax`,
	"modalFooter": `modalFooter__wK7wQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
